// extracted by mini-css-extract-plugin
export default {"group":"SiteSidebar_group__XE-iE"};